<div class="label" [ngClass]="labelClass()">
  {{ label() | translate }}
</div>

<div class="value" [ngClass]="valueClass()">
  @if (value()) {
    @if (iconUrl()) {
      <img [src]="iconUrl()" alt="Icon" [width]="12" [height]="16" />
    }

    @if (iconName()) {
      <fu-icon [iconName]="iconName()" size="12" />
    }

    {{ value() }}

    @if (tooltipValue()) {
      <iw-tooltip [title]="tooltipValue()" [maxWidth]="326" position="bc" />
    }
  }

  <!-- optional projected content after the value -->
  <ng-content></ng-content>

  @if (withCopyBtn()) {
    <iw-button
      class="copy-btn"
      size="s"
      uiType="custom"
      [onlyIcon]="true"
      (click)="onCopy($event)"
    >
      <fu-icon iconName="copy" size="16" />
    </iw-button>
  }
</div>
